import { customersDataHelper } from "./customers-data-helper";

export const topUpData = [

  {
    id: "a0456-5648cc43-5648cc43-237d0098-1ac2",
    amount: 200000.55,
    transactionType: "topUp",
    currency: "NGN",
    currencySymbol: "₦",
    status: "Processing",
    description: "STA-23493-3233",
    customer: customersDataHelper[1],
    gatewayId: "STANDARD CHARTERD ……….9032",
    gatewayLogoUrl: "gateway-logos/flutterwave.svg",
    date: "Jun 13",
  },
  {
    id: "a0456-5648cc43-5648cc43-237d0098-1ac3",
    amount: 2000.55,
    transactionType: "topUp",
    currency: "USD",
    currencySymbol: "$",
    status: "Paid",
    description: "STA-23493-3233",
    customer: customersDataHelper[1],
    gatewayId: "STANDARD CHARTERD ……….9032",
    gatewayLogoUrl: "gateway-logos/flutterwave.svg",
    date: "Jun 13",
  },
  {
    id: "a0456-5648cc43-5648cc43-237d0098-1ac4",
    amount: 2500.55,
    transactionType: "topUp",
    currency: "USD",
    currencySymbol: "$",
    status: "Paid",
    description: "STA-23493-3233",
    customer: customersDataHelper[1],
    gatewayId: "STANDARD CHARTERD ……….9032",
    gatewayLogoUrl: "gateway-logos/flutterwave.svg",
    date: "Jun 13",
  },
  {
    id: "a0456-5648cc43-5648cc43-237d0098-1ac5",
    amount: 3500.55,
    transactionType: "topUp",
    currency: "EURO",
    currencySymbol: "#",
    status: "Paid",
    description: "STA-23493-3233",
    customer: customersDataHelper[1],
    gatewayId: "STANDARD CHARTERD ……….9032",
    gatewayLogoUrl: "gateway-logos/flutterwave.svg",
    date: "Jun 13",
  },
  
];
